module.exports = __webpack_public_path__ + "static/media/citrus_grove-blurred.c1f954ce.jpg";